import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=29c8c63f&scoped=true&"
var script = {}
import style0 from "./cookie.vue?vue&type=style&index=0&id=29c8c63f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c8c63f",
  null
  
)

export default component.exports